import { getDeviceInfo } from './getDeviceInfo';
var mobilePlatforms = new Set([
    "AndroidPhone" /* PlatformType.AndroidPhone */,
    "iPhone" /* PlatformType.iPhone */,
    "WindowsPhone" /* PlatformType.WindowsPhone */,
]);
export function getIsMobile() {
    var deviceInfo = getDeviceInfo();
    return mobilePlatforms.has(deviceInfo.platform.platformType);
}
//# sourceMappingURL=getIsMobile.js.map